import { useEffect, useState } from "react";
//#region src/flags/FeatureFlagGate.tsx
var FeatureFlagGate = ({ flag, evaluate, enabled: enabledComponent, disabled: disabledComponent, loading: loadingComponent, forceDisabled = false }) => {
	if (forceDisabled) return disabledComponent;
	const { enabled, loading } = evaluate(flag);
	if (loading) return loadingComponent ?? disabledComponent;
	return enabled ? enabledComponent : disabledComponent;
};
var useAsyncFlag = (flag, evaluate, skip) => {
	const [state, setState] = useState({
		enabled: false,
		loading: !skip
	});
	useEffect(() => {
		if (skip) {
			setState({
				enabled: false,
				loading: false
			});
			return;
		}
		let stale = false;
		setState({
			enabled: false,
			loading: true
		});
		(async () => {
			try {
				const enabled = await evaluate(flag);
				if (stale) return;
				setState({
					enabled,
					loading: false
				});
			} catch (error) {
				if (stale) return;
				setState({
					enabled: false,
					loading: false
				});
				console.error("AsyncFeatureFlagGate: evaluator threw for flag", flag, error);
			}
		})();
		return () => {
			stale = true;
		};
	}, [
		evaluate,
		flag,
		skip
	]);
	return state;
};
var AsyncFeatureFlagGate = ({ flag, evaluate, enabled: enabledComponent, disabled: disabledComponent, loading: loadingComponent, forceDisabled = false }) => {
	const { enabled, loading } = useAsyncFlag(flag, evaluate, forceDisabled);
	if (forceDisabled) return disabledComponent;
	if (loading) return loadingComponent ?? disabledComponent;
	return enabled ? enabledComponent : disabledComponent;
};
//#endregion
export { AsyncFeatureFlagGate, FeatureFlagGate };

